import { Accordion, Badge, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { ProductResponses } from "@tfg/types/endpoints/products"

interface Props {
  composition: ProductResponses.RDUEProduct["composition"]
}
export const CompositionCell = ({ composition }: Props) => {
  const { t } = useTranslation("regulations")

  return (
    <Accordion w={400}>
      <Accordion.Item value="composition">
        <Accordion.Control>
          <Text>
            {t("columns.rdue.compositionCount", {
              count: composition.length,
            })}
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          {composition.map((material) => (
            <Badge key={material} c="gray">
              {material}
            </Badge>
          ))}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  )
}
